import { useState } from "react";
import { MailCheck } from "lucide-react";
import api from "@/lib/api";
import { AuthShell, inputCls, labelCls } from "@/components/AuthShell";
import { FORGOT } from "@/constants/testIds/auth";

const GENERIC_MSG = "If this email exists, a reset link has been sent.";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
    } catch {
      // Generic response regardless of outcome
    } finally {
      setBusy(false);
      setSent(true);
    }
  };

  return (
    <AuthShell testId={FORGOT.page} backTestId={FORGOT.backToLoginLink}
      title="Forgot password?" subtitle="Enter your email and we'll send you a link to reset it.">
      {sent ? (
        <div className="rounded-2xl bg-rose-50 border border-rose-200 p-5 flex gap-3 items-start" data-testid={FORGOT.successMessage}>
          <MailCheck className="w-5 h-5 terracotta shrink-0 mt-0.5" />
          <div>
            <p className="text-charcoal font-semibold">{GENERIC_MSG}</p>
            <p className="text-sm text-charcoal/60 mt-1">The link expires in 1 hour. Check your spam folder too.</p>
          </div>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className={labelCls}>Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className={inputCls} placeholder="you@example.com" data-testid={FORGOT.emailInput} />
          </div>
          <button type="submit" disabled={busy} className="w-full pill-btn pill-btn-primary mt-2" data-testid={FORGOT.submitButton}>
            {busy ? "Sending..." : "Send reset link"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
